import RiskReportCard from '../RiskReportCard';
import { useRiskReportDoc } from './helpers';

type RiskReportCardContainerProps = { accountId: string };

const RiskReportCardContainer = (props: RiskReportCardContainerProps) => {
  const riskReportDoc = useRiskReportDoc({
    accountId: props.accountId,
  });

  return (
    <RiskReportCard
      downloadReport={riskReportDoc.methods.downloadReport}
      downloadDisabled={riskReportDoc.isDownloadDisabled}
      generateReport={riskReportDoc.methods.generateReport}
      redirectToAddDomain={riskReportDoc.methods.redirectToAddDomain}
      generateDisabled={riskReportDoc.isGenerationDisabled}
      latestReportDate={riskReportDoc.data.latestReportDate}
      isRiskScannerRunning={riskReportDoc.isRiskScannerRunning}
      isReportGenerating={riskReportDoc.isReportGenerating}
      accountHasDomain={riskReportDoc.data.accountHasDomain}
    />
  );
};

export default RiskReportCardContainer;
